export class NetworkError extends Error {
    constructor(errorCode, message = `Network error [${errorCode}]`) {
        super(message);
        this.errorCode = errorCode;
        Object.setPrototypeOf(this, NetworkError.prototype);
    }
}
